import Product from "components/common/product-thumb"
import { useTranslation } from "lib/i18n/translation"

export default ({ treasure, products, loading }) => {
	const { c } = useTranslation("common")

	return (
		<section>
			{
				treasure
				&& <h2 className="section-title icon-eye">
					{c("movies-proposed-by")}{" "}
					<strong>{treasure.name}</strong>
				</h2>
			}
			<ul className="grid films">
				{products.map((product, index) => (
					<Product
						key={`treasure-product-${index}`}
						product={product}
						loading={loading}
					/>
				))}
			</ul>
		</section>
	)
}
